import { Box } from '@mui/material';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

export default function OnlineCartStepTransition({ transitionKey, direction = 'forward', onStepEntered, children }) {
    return (
        <Box
            sx={{
                '& .online-cart-step-appear': {
                    opacity: 0,
                    transform: `translateX(${direction === 'forward' ? '40px' : '-40px'})`,
                },
                '& .online-cart-step-appear-active': {
                    opacity: 1,
                    transform: 'translateX(0)',
                    transition: 'opacity 260ms ease-out, transform 260ms ease-out',
                },
                '& .online-cart-step-enter': {
                    opacity: 0,
                    transform: `translateX(${direction === 'forward' ? '40px' : '-40px'})`,
                },
                '& .online-cart-step-enter-active': {
                    opacity: 1,
                    transform: 'translateX(0)',
                    transition: 'opacity 260ms ease-out, transform 260ms ease-out',
                },
                '& .online-cart-step-exit': {
                    opacity: 1,
                    transform: 'translateX(0)',
                },
                '& .online-cart-step-exit-active': {
                    opacity: 0,
                    transform: `translateX(${direction === 'forward' ? '-40px' : '40px'})`,
                    transition: 'opacity 220ms ease-out, transform 220ms ease-out',
                },
                '@media (prefers-reduced-motion: reduce)': {
                    '& .online-cart-step-appear': {
                        opacity: 1,
                        transform: 'none',
                    },
                    '& .online-cart-step-appear-active': {
                        opacity: 1,
                        transform: 'none',
                        transition: 'none',
                    },
                    '& .online-cart-step-enter': {
                        opacity: 1,
                        transform: 'none',
                    },
                    '& .online-cart-step-enter-active': {
                        opacity: 1,
                        transform: 'none',
                        transition: 'none',
                    },
                    '& .online-cart-step-exit': {
                        opacity: 1,
                        transform: 'none',
                    },
                    '& .online-cart-step-exit-active': {
                        opacity: 1,
                        transform: 'none',
                        transition: 'none',
                    },
                },
            }}
        >
            <SwitchTransition mode="out-in">
                <CSSTransition
                    key={transitionKey}
                    classNames="online-cart-step"
                    timeout={{ appear: 260, enter: 260, exit: 220 }}
                    appear
                    unmountOnExit
                    onEntered={onStepEntered}
                >
                    <Box>{children}</Box>
                </CSSTransition>
            </SwitchTransition>
        </Box>
    );
}
